export function setWindowAttr(key: string, value: any) {
  (window as any)[key] = value;
}
